import React from "react";
import PropTypes from "prop-types";
import MuiLink from "@mui/material/Link";
import Link from "arena/components/Link";
import { useArena } from "core/components/ArenaProvider";
import getShelfLinkProps from "core/utils/getShelfLinkProps";

const linkStyle = { textDecoration: "none", color: "inherit" };

export default function ShelfTitleLink({ url, children }) {
  const arena = useArena();
  const { isExternal, to, href } = getShelfLinkProps(url, arena.url);

  if (isExternal) {
    return (
      <MuiLink
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={linkStyle}
      >
        {children}
      </MuiLink>
    );
  }

  return (
    <Link to={to} style={linkStyle}>
      {children}
    </Link>
  );
}

ShelfTitleLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
